import React, { ReactElement, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Dispatch } from 'redux';

import { RootState } from '../../types/state/root.types';
import { SystemState } from '../../types/state/system.types';

import { setNewNotifications } from '../../slices/system/system.slice';

import Header from '../../components/common/header/Header';

const HeaderContainer = (): ReactElement => {
  const [showNotifications, setShowNotifications] = useState<boolean>(false);
  const [showProfile, setShowProfile] = useState<boolean>(false);

  const { newNotifications } = useSelector(({ system }: RootState): SystemState => system);

  const dispatch: Dispatch = useDispatch();

  const toggleNotifications = (): void => {
    setShowNotifications((prevState: boolean): boolean => !prevState);
    setShowProfile(false);

    if (newNotifications && !showNotifications) {
      dispatch(setNewNotifications(false));
    }
  };

  const toggleProfile = (): void => {
    setShowProfile((prevState: boolean): boolean => !prevState);
    setShowNotifications(false);
  };

  return (
    <Header
      showNotifications={showNotifications}
      showProfile={showProfile}
      newNotifications={newNotifications}
      toggleNotifications={toggleNotifications}
      toggleProfile={toggleProfile}
    />
  );
};

export default HeaderContainer;
